import { GetFormularioRespostaByAssociacao } from "@services/Formulario/Index";
import { GetAllPlanosAcaoByIdProcessoAndIdUnidadeGerencia } from "@services/PlanoAcao/Index";

export default function ValidationsAnswerSolicitacao() {

    // Verifica se há pelo menos um plano de ação para o relatório associado ao mesmo processo e unidade/gerencia
    async function validatePlanoAcao(idProcesso, idUnidadeGerencia) {

        try {
            const resposta = await GetAllPlanosAcaoByIdProcessoAndIdUnidadeGerencia(
                1, 100,
                idProcesso,
                idUnidadeGerencia
            );

            const planos = resposta?.items || [];

            if (planos.length === 0) {
                return {
                    html: `
                        <p>Existe relatório(s) anexado(s), mas nenhum plano de ação foi encontrado para o processo/unidade informados.</p>
                        <p><strong>Um plano de ação deve ser anexado.</strong></p>
                    `,
                    missing: true,
                };
            }

            return null; // tudo certo
        } catch (error) {
            return {
                html: `
                <p>Erro ao verificar os planos de ação:</p>
                <p><strong>Não foi possível validar se existe plano de ação anexado.</strong></p>
                `,
                missing: true,
            };
        }
    }

    // Percorre a lista de solicitacaoProcessoItem e verifica se existe resposta para os itens com formularios associados
    async function validateFormularioRespostaItemProcesso(idSolicitacao, solicitacaoProcessoItems) {
        const faltantes = []

        for (const item of solicitacaoProcessoItems) {
            if (item.formularioAssociadoItemProcesso?.id) {
                try {
                    const resp = await GetFormularioRespostaByAssociacao(idSolicitacao, item.formularioAssociadoItemProcesso.id)
                    if (!resp) {
                        faltantes.push(item.nomeItem)
                    }
                } catch {
                    faltantes.push(item.nomeItem)
                }
            }
        }

        if (faltantes.length > 0) {
            // monta uma lista HTML com nomes em negrito
            const html = `
                <p>Faltam respostas para os seguintes itens do processo:</p>
                ${faltantes.map(name => `<li><strong>${name}</strong></li>`).join('')}`

            return { html, missingItems: faltantes }
        }
        return null
    }

    // Se houver um formulario associado ao processo, verifica se o usaurio respondeu esse formulario
    async function validateFormularioRespostaProcesso(idSolicitacao, formularioAssociadoProcesso) {

        // Se não há formulário associado, nada a validar
        if (!formularioAssociadoProcesso?.id) {
            return null;
        }

        try {
            // Tenta buscar a resposta para este formulário de processo
            const resp = await GetFormularioRespostaByAssociacao(idSolicitacao, formularioAssociadoProcesso.id);

            // Se não existir resposta, monta mensagem de erro
            if (!resp) {
                const titulo = formularioAssociadoProcesso.titulo || 'processo';
                const html = `
                    <p>Falta responder o formulário de processo associado:</p>
                    <p><strong>${titulo}</strong></p>
                `;
                return { html, missing: true };
            }

            // Tudo ok
            return null;
        } catch (err) {
            // Em caso de falha no fetch, também reportamos
            const titulo = formularioAssociadoProcesso.titulo || 'processo';
            const html = `
            <p>Não foi possível verificar a resposta do formulário de processo:</p>
            <p><strong>${titulo}</strong></p>
            `;
            return { html, missing: true };
        }
    }

    return {
        validatePlanoAcao,
        validateFormularioRespostaItemProcesso,
        validateFormularioRespostaProcesso
    };
}
